import React, { Component } from "react";
import { _crud } from "../../../utils/crud";

class SouscriptionList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      List: {
        datas: [],
        message: null,
        state: false,
        isLoading: false,
        empty: false,
      },
      TotGenerale: null,
    };
  }

  onGet = () => {
    this.setState({
      List: {
        datas: [],
        message: null,
        state: false,
        isLoading: true,
        empty: false,
      },
      TotGenerale: null,
    });

    var datas = {
      id: "eff",
    };

    _crud("get", "souscription", datas, (state, response) => {
      if (state) {
        response.data.data.sort((a, b) => {
          if (b.createdAt > a.createdAt) {
            return 1;
          }
          return -1;
        });

        this.setState({
          List: {
            datas: response.data.data,
            message: response.message,
            state: true,
            isLoading: false,
            empty: false,
          },
          TotGenerale: response?.data?.totalGeneral,
        });
      } else {
        this.setState({
          List: {
            datas: null,
            message: response,
            state: true,
            isLoading: false,
            empty: true,
          },
        });
      }
    });
  };

  componentDidMount() {
    this.onGet();
  }

  render() {
    var { List, TotGenerale } = this.state;
    return (
      <>
        <div className="col-12">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h2 class="h5 page-title" id="task-section">
                Gestion de Souscription
              </h2>
              <p class="text-muted">Liste générale de souscriptions</p>
            </div>
            <a href="/talyva/souscription-collecte/souscription">
              Nouvelle Souscription
            </a>
          </div>

          <div className="row">
            <div class="col-md-12 my-4">
              <div class="card shadow">
                <div class="card-body">
                  <h5 class="card-title">Grille de souscriptions</h5>
                  <h5 class="card-title text-danger">
                    Total Général :{" "}
                    {new Intl.NumberFormat().format(TotGenerale)}
                  </h5>

                  <table class="table table-sm">
                    <thead class="thead-dark">
                      <tr>
                        <th>#</th>
                        <th>NOM COMPLET</th>
                        <th>OPERATION</th>
                        <th>MONTANT</th>
                        <th>DATE</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {List.state &&
                        List.datas &&
                        List.datas.map((x, i = 0) => {
                          return (
                            <tr key={x.id}>
                              <td>{i < 10 ? "0" + ++i : ++i}</td>
                              <td>
                                <p class="mb-0 text-secondary">
                                  {x.Fidele.nomComplet}
                                </p>
                              </td>
                              <td>
                                <p class="text-danger">
                                  {x.Operation.description}
                                </p>
                              </td>
                              <td>
                                <p class="text-primary">
                                  <a href="#0" class="text-info">
                                    {`${x.montant} ${
                                      x.Operation.devise === `USD`
                                        ? `$`
                                        : x.Operation.devise === `CDF`
                                        ? `Fc`
                                        : `Aucune Devise`
                                    }`}
                                  </a>
                                </p>
                              </td>
                              <td>
                                <p class="text-primary">
                                  <a href="#0" class="text-secondary">
                                    {new Intl.DateTimeFormat("fr-FR", {
                                      dateStyle: "long",
                                    }).format(new Date(x.createdAt))}
                                  </a>
                                </p>
                              </td>
                              <td>
                                <button
                                  class="btn btn-sm dropdown-toggle more-horizontal"
                                  type="button"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <span class="text-muted sr-only">Action</span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                  <a class="dropdown-item" href="#0">
                                    Détail
                                  </a>
                                  <a class="dropdown-item" href="#0">
                                    Modification
                                  </a>
                                  <a class="dropdown-item" href="#0">
                                    Supprimer
                                  </a>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  <nav aria-label="Table Paging" class="mb-0 text-muted">
                    <ul class="pagination justify-content-center mb-0">
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          Précédent
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          1
                        </a>
                      </li>
                      <li class="page-item active">
                        <a class="page-link" href="#0">
                          2
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          3
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          Suivant
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              {/* <div class="card shadow">
                <div class="card-body">
                  <div class="toolbar">
                    <form class="form">
                      <div class="form-row">
                        <div class="form-group col-4">
                          <label for="search" class="sr-only">
                            Recherche
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="recherche"
                            value=""
                            placeholder="Recherche..."
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <table class="table table-borderless table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>NOM COMPLET</th>
                        <th>SEXE</th>
                        <th>CONTACT</th>
                        <th>ADRESSE</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {List.state &&
                        List.datas.map((x, i = 0) => {
                          return (
                            <tr key={x.id}>
                              <td>{i < 10 ? "0" + ++i : ++i}</td>
                              <td>
                                <p class="mb-0 text-muted">
                                  <strong>{x.nomComplet}</strong>
                                </p>
                              </td>
                              <td>
                                <p class="mb-0 text-muted">
                                  {x.sexe === `M`
                                    ? `Masculin`
                                    : x.sexe === `F`
                                    ? `Féminin`
                                    : `Aucun`}
                                </p>
                              </td>
                              <td>
                                <p class="mb-0 text-muted">
                                  <a href="#0" class="text-muted">
                                    {x.telephone.principal}
                                  </a>
                                </p>
                              </td>
                              <td class="w-25">
                                <small class="text-muted">{`${x.adresse}, ${x.commune}`}</small>
                              </td>
                              <td>
                                <button
                                  class="btn btn-sm dropdown-toggle more-horizontal"
                                  type="button"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <span class="text-muted sr-only">Action</span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                  <a class="dropdown-item" href="#0">
                                    Détail
                                  </a>
                                  <a class="dropdown-item" href="#0">
                                    Modification
                                  </a>
                                  <a class="dropdown-item" href="#0">
                                    Supprimer
                                  </a>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  <nav aria-label="Table Paging" class="mb-0 text-muted">
                    <ul class="pagination justify-content-center mb-0">
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          Précédent
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          1
                        </a>
                      </li>
                      <li class="page-item active">
                        <a class="page-link" href="#0">
                          2
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          3
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link" href="#0">
                          Suivant
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SouscriptionList;
